import { Add, Delete, Edit } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { OrganizationUnit } from '~/data/orgunits/types';
import { WorkflowConfig } from '~/data/workflows';
import { useVisible } from '~/hooks/useVisible';
import { OrgUnitLabel } from '~/scenes/AdminModule/components/Views/WorkflowsConfigurationView/components/OrgUnitLabel';
import { WorkflowEditProps } from '~/scenes/AdminModule/components/Views/WorkflowsConfigurationView/components/WorkflowConfigurationsTable/component';
import {
  WorkflowProcessConfigState,
  getWorkflowProcessTypeTranslationKeyFromString,
} from '~/scenes/AdminModule/components/Views/WorkflowsConfigurationView/data';
import { theme } from '~/theme';

type PropsType = {
  orgUnit: OrganizationUnit | undefined;
  workflowConfig: WorkflowConfig;
  workflowState: WorkflowProcessConfigState;
  onDelete: (workflowId: string) => void;
  onEdit: (editProps: WorkflowEditProps) => void;
  unitConfigsEnabled: boolean;
};

export const WorkflowRowActions = (props: PropsType) => {
  const { t } = useTranslation();
  const {
    workflowConfig,
    workflowState,
    onEdit,
    onDelete,
    orgUnit,
    unitConfigsEnabled,
  } = props;
  const { isVisible, show, hide } = useVisible(false);

  const isEdit = workflowState === WorkflowProcessConfigState.Unit;
  const handleConfirm = () => {
    onDelete(workflowConfig.id);
    hide();
  };

  const processTypeLabel = t(
    getWorkflowProcessTypeTranslationKeyFromString(workflowConfig.processType),
  );

  return (
    <>
      <IconButton
        onClick={() =>
          onEdit({
            workflowConfig,
            isEdit,
          })
        }
        title={t(isEdit ? 'edit' : 'create')}
      >
        {isEdit ? <Edit /> : <Add />}
      </IconButton>
      {isEdit && (
        <IconButton onClick={() => show()} title={t('delete')}>
          <Delete />
        </IconButton>
      )}
      {isVisible && (
        <Dialog open={isVisible} onClose={hide}>
          <Box sx={{ padding: theme.spacing(2, 2, 1, 2), minWidth: '300px' }}>
            <Typography variant={'h6'}>{t('deleteWorkflow')}</Typography>
            <Box sx={{ margin: theme.spacing(1, 0) }}>
              {processTypeLabel}
              {!!orgUnit && unitConfigsEnabled && (
                <>
                  {' - '}
                  <OrgUnitLabel orgUnit={orgUnit} variant={'inline'} />
                </>
              )}
            </Box>
            {unitConfigsEnabled && (
              <Typography
                variant={'caption'}
                component={'p'}
                sx={{ margin: theme.spacing(1, 0) }}
              >
                {t('deleteWorkflowConsequence')}
              </Typography>
            )}
          </Box>
          <DialogActions>
            <Button onClick={hide}>{t('cancel')}</Button>
            <Button
              onClick={() => handleConfirm()}
              variant={'contained'}
              color={'secondary'}
            >
              {t('confirm')}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
